/**
 * DescriptionClassificationContainer component.
 */
import styled from 'styled-components';

/**
 * Horizontal flex row for the commercial score and parental age code on the description page.
 */
const DescriptionClassificationContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export default DescriptionClassificationContainer;
